export default function getPaginatedItems(items, pageOffset, pageSize) {
  if (items && items.length > 0) {
    return items.slice(pageOffset, pageOffset + pageSize);
  } else {
    return items;
  }
}
